export default {
    _prefix: "PreviewTag",
    label: "Preview",
    tooltip:
        "This is a preview version of AI Scoring. Proficiency may differ between languages.",
};
